import TabHeader from "./TabHeader";
import SearchBox from "./SearchBox";
import Functionality from "./Functionality";
import CommentDetails from "./CommentDetails";
import QueryCountDetailComponent from "./QueryCountDetailComponent";
import "./ReportBugandImprovement.css";
import VisibleAllDetails from "./VisibleAllDetails";
import { useCommentData } from "./CommentDataContext";
import CloseIcon from "@mui/icons-material/Close";
import ToolManager from "../../libraries/ToolManager";
import SubmitComment from "./SubmitComment";

const ReportBugandImprovement = ({ setBugsection }) => {
  const { seeAllDots } = useCommentData();
  const handleClose = () => {
    ToolManager.setTool("select");
    window.dispatchEvent(new CustomEvent("tool-changed", { detail: "select" }));
    setBugsection(false);
  };
  return (
    <div className="report-container">
      <button
        className="icon-close"
        onClick={handleClose}
        aria-label="close"
        title="close"
      >
        <CloseIcon />
      </button>
      <TabHeader />
      <Functionality />
      <SearchBox />
      <QueryCountDetailComponent />
      {seeAllDots ? <VisibleAllDetails /> : null}
      {!seeAllDots && <CommentDetails />}
      {!seeAllDots && <SubmitComment />}
    </div>
  );
};

export default ReportBugandImprovement;
